import { combineReducers } from 'redux';
import { addToPagination, createPagination } from 'redux/helpers/pagination';
import types from './types';

const allPages = (state = createPagination(null, 'pageIds'), { type, payload }) => {
  switch (type) {
    case types.getPagesSuccess:
      return addToPagination(state, null, payload, 'pageIds');
    default:
      return state;
  }
};

const allCategories = (state = [], { type, payload }) => {
  switch (type) {
    case types.getCategoriesSuccess:
      return payload.data;
    case types.deleteCategorySuccess:
      return [...state].filter(id => id !== payload.request.categoryId);
    case types.createCategorySuccess:
      return [...state, payload.data];
    default:
      return state;
  }
};

const knowledgeHubCategories = (state = [], { type, payload }) => {
  switch (type) {
    case types.getKnowledgeHubSuccess:
      return payload.data.categories;
    case types.deleteCategorySuccess:
      return [...state].filter(id => id !== payload.request.categoryId);
    case types.createCategorySuccess:
      return [...state, payload.data];
    default:
      return state;
  }
};
const knowledgeHubRootPages = (state = [], { type, payload }) => {
  switch (type) {
    case types.getKnowledgeHubSuccess:
      return payload.data.rootPages;
    default:
      return state;
  }
};

const pages = combineReducers({
  allPages,
  allCategories,
  knowledgeHubCategories,
  knowledgeHubRootPages,
});

export default { pages };
